import React, { Component } from 'react';
export const Page = props => (
  <div className="project">

    {/* ==== EDIT BELOW THIS LINE ==== */}
    
    <h1> Spider Brooch </h1>

    
    <div className="imgs max800">
        <div>
            <img src={require('../assets/mixedMedia/spider/1.png')} data-skip-gallery/>
        </div>
    </div>

    <p>I created this piece during my interdisciplinary studies at Carnegie 
    Mellon University in the course <a href="https://www.phipps.conservatory.org/" target="_blank">52-392</a>, "BXA Seminar III: Deconstructing Disciplines". 
    This class was focused on the examination of different disciplines and where they may cross over. For my final project, 
    I wanted to further explore my interdisciplinary topic of beauty verses disgust. These are both psychological reactions one 
    has to stimulation such as visual input. To explore this topic, I wanted to create a sculpture that invoked both feelings of 
    beauty and disgust by using the visual of a spider, a form that triggers disgust for many humans, but make it beautiful by 
    mimicking a decorative brooch. Thus, I created a "spider brooch".</p>


    <div className="imgs max800">
        <div>
            <img src={require('../assets/mixedMedia/spider/2.png')} data-skip-gallery/>
        </div>
    </div>

    {/* ==== EDIT ABOVE THIS LINE ==== */}

  </div>
)






// worked with the rabbi to developed visual 
    //symbols to represent each of the prayers in the Shabbat in order to guide the members 
    //with ASD through the ceremony. These symbols will be presented to the members via a 
    //large banner on the temple’s stage as well as on personal bookmarks that correspond 
    //with the banner. The bookmarks will also have a sticker packet with the symbols printed 
    //as stickers, to be placed on each of the corresponding sections for the current prayer 
    //on the bookmarks. The visually and physically interactive elements of these materials 
    //will help to add more sensorial aspects to the Shabbat, further benefitting Temple Sinai’s members with ASD.